import React from "react";
import { Tag } from "@dtsl/react/dist/components/Tag";
import styles from "./jsonViewer.module.less";
import { isLink } from "./helper";
export const theme = {
  scheme: "brevo",
  author: "ayush maheshwari",
  base00: "var(--surface-light-grey-sidebar, #f5f5f5);",
  base01: " var(--content-primary, #1B1B1B)",
  base02: " var(--content-primary, #1B1B1B)",
  base03: " var(--content-primary, #1B1B1B)",
  base04: " var(--content-primary, #1B1B1B)",
  base05: " var(--content-primary, #1B1B1B)",
  base06: " var(--content-primary, #1B1B1B)",
  base07: " var(--content-primary, #1B1B1B)",
  base08: " var(--content-primary, #1B1B1B)",
  base09: " var(--content-primary, #1B1B1B)",
  base0A: " var(--content-primary, #1B1B1B)",
  base0B: " var(--content-primary, #1B1B1B)",
  base0C: " var(--content-primary, #1B1B1B)",
  base0D: " var(--content-primary, #1B1B1B)",
  base0E: " var(--content-primary, #1B1B1B)",
  base0F: " var(--content-primary, #1B1B1B)"
};
export const getNestedLabelStyle = _ref => {
  let {
    style
  } = _ref;
  return {
    style: {
      ...style,
      marginBottom: "0.5rem",
      textTransform: "none"
    }
  };
};
export const getValueLabelStyle = _ref2 => {
  let {
    style
  } = _ref2;
  return {
    style: {
      ...style,
      marginBottom: "0.5rem"
    }
  };
};
export const getArrowStyle = _ref3 => {
  let {
    style
  } = _ref3;
  return {
    style: {
      ...style,
      color: "var(--content-primary, #1B1B1B)"
    }
  };
};
export const getArrowContainerStyle = _ref4 => {
  let {
    style
  } = _ref4;
  return {
    style: {
      ...style,
      textAlign: "center"
    }
  };
};
export const getItemString = (type, data, itemType, itemString) => {
  return /*#__PURE__*/React.createElement(Tag, {
    label: itemString.split(" ")[0],
    border: true
  });
};
export const valueRenderer = raw => {
  if (isLink(raw)) {
    const newRaw = raw.substr(1, raw.length - 2);
    return /*#__PURE__*/React.createElement("span", {
      className: styles["link-text"]
    }, " ", newRaw);
  }
  return /*#__PURE__*/React.createElement("span", {
    className: styles["value-text"]
  }, " ", raw);
};
export const labelRenderer = (_ref5, nodeType, expanded, expandable) => {
  let [raw] = _ref5;
  if (!expandable) return /*#__PURE__*/React.createElement("span", {
    className: styles["label-text"]
  }, " ", raw, " :");
  return /*#__PURE__*/React.createElement("span", {
    className: styles["label-text"]
  }, " ", raw);
};